import { render, staticRenderFns } from "./Informacao.vue?vue&type=template&id=42dad84b"
import script from "./Informacao.vue?vue&type=script&lang=js"
export * from "./Informacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports